export function formatFileSize(fileSize: number) {
  if (fileSize < 1000000) {
    return Math.floor(fileSize / 1000) + " kB";
  }
  return Math.floor(fileSize / 1000000) + " MB";
}
